import React from 'react';
import {
  IconButton,
  Tooltip,
  Box,
  alpha,
  useTheme
} from '@mui/material';
import { useLanguage } from '../../contexts/LanguageContext';

// Flag components using Unicode flags
const FlagIcon = ({ countryCode, size = 24 }) => {
  const flagMap = {
    'PT': '🇵🇹', // Portuguese flag
    'US': '🇺🇸', // US flag for English
    'GB': '🇬🇧'  // UK flag alternative
  };

  return (
    <Box
      sx={{
        fontSize: `${size}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        lineHeight: 1
      }}
    >
      {flagMap[countryCode] || '🌐'}
    </Box>
  );
};

const LanguageSwitcher = ({ showTooltip = true, size = 'medium' }) => {
  const theme = useTheme();
  const { changeLanguage, isPortuguese } = useLanguage();

  const handleLanguageToggle = () => {
    changeLanguage(isPortuguese ? 'en' : 'pt');
  };

  const getNextLanguageLabel = () => {
    return isPortuguese ? 'Switch to English' : 'Mudar para Português';
  };

  const iconSize = size === 'small' ? 20 : size === 'large' ? 28 : 24;

  const switcher = (
    <IconButton
      onClick={handleLanguageToggle}
      sx={{
        borderRadius: 2,
        bgcolor: alpha(theme.palette.primary.main, 0.08),
        border: `1px solid ${alpha(theme.palette.primary.main, 0.12)}`,
        '&:hover': {
          bgcolor: alpha(theme.palette.primary.main, 0.12),
          borderColor: alpha(theme.palette.primary.main, 0.24),
        },
        transition: 'all 0.2s ease-in-out',
        width: size === 'small' ? 32 : size === 'large' ? 48 : 40,
        height: size === 'small' ? 32 : size === 'large' ? 48 : 40,
      }}
    >
      <FlagIcon 
        countryCode={isPortuguese ? 'PT' : 'US'} 
        size={iconSize}
      />
    </IconButton>
  );

  if (showTooltip) {
    return (
      <Tooltip 
        title={getNextLanguageLabel()}
        placement="bottom"
        arrow
      >
        {switcher}
      </Tooltip>
    );
  }

  return switcher;
};

export default LanguageSwitcher; 